import * as ngCore from '@angular/core'
import * as store from '@attain-apps/fe/web/main/lib/store'

import * as _internal from './internal'
import type * as models from './models'

/**
 * TODO:
 */
@ngCore.Injectable({ providedIn: 'root' })
export class ClipboardService {
  /**
   * This property is intended for internal use only. Ideally, it should be
   * private, but it is public for specific reasons (e.g., effects). The
   * underscore prefix indicates that this property is not meant to be accessed
   * from outside this class.
   *
   * @internal
   */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly _feature
  // TODO: js doc
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly canPaste
  // TODO: js doc
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly copy
  // TODO: js doc
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly paste
  // TODO: js doc
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly openDialog

  constructor() {
    this._feature = new store.Feature({
      actions: _internal.getActionsConfig(this),
      initialState: _internal.State.INITIAL,
      name: 'Clipboard',
      selectors: () => new _internal.Selectors(this),
    })

    this._feature.registerEffects(_internal.effects.pasteSelected())
    this.canPaste = this._feature.selectors.canPaste

    // TODO: We should create a methods that calls this under the hood.
    this.copy = this._feature.actions.copy
    this.paste = this._feature.actions.openDialog
    this.openDialog = this._feature.actions.openDialog
  }
}
